'use client';
import { Hidden } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@ui/Dialog';
import Typography from '@ui/Typography';
import React, { useEffect, useState } from 'react';
import { MdArrowBackIos } from 'react-icons/md';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import PostType, { CampaignType } from '@/constants/postType.constants';
import useStore from '@/stores/store';
import FundraiseTemplateCard from './FundraiseTemplateCard';
import StyledTextButton from '@/components/Styled/StyledTextButton';
import CreateCampaignDialogTemplate from '../CreateCampaignDialog/CreateCampaignDialogTemplate';
import CreateCrowdFundingDialogTemplate from '../CreateCrowdFundingDialog/CreateCrowdFundingDialogTemplate';
import {
  CROWDFUNDS,
  FUNDRAISERS,
  getFundRaiseTemplates,
} from './FundraiseTemplates';

function CreateFundraiseDialog(props) {
  const { open, post = null, type, onClose } = props;
  const theme = useTheme();
  const userProfile = useStore((state) => state.user.profile);
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isLessThanSmallScreen = useBreakpointHooks((bp) => bp.useSmaller('sm'));

  const [stepNum, setStepNum] = useState(0);
  const [headerText, setHeaderText] = useState('Fundraise');
  const [templates, setTemplates] = useState(
    getFundRaiseTemplates(userProfile),
  );
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedTemplateIndex, setSelectedTemplateIndex] = useState(-1);

  const isEditMode = !!post;

  useEffect(() => {
    setTemplates(getFundRaiseTemplates(userProfile));
  }, [open, isEditMode, type, userProfile]);

  const closeDialog = () => {
    setSelectedTemplateIndex(-1);
    setSelectedTemplate(null);
    setHeaderText('Fundraise');
    setStepNum(0);
    onClose();
  };

  const handleBack = () => {
    if (isEditMode) {
      closeDialog();
    } else {
      setStepNum(stepNum - 1);
      if (stepNum - 1 === 0) {
        handleUpdateHeader('Fundraise');
      }
    }
  };

  const handleClose = () => {
    // if (stepNum === 1) {
    //   handleBack();
    // } else {
    //   closeDialog();
    // }

    closeDialog();
  };

  const handleUpdateHeader = (header) => {
    setHeaderText(header);
  };

  const handleTemplateSelection = (index) => {
    if (index >= 0) {
      setSelectedTemplateIndex(index);
      setSelectedTemplate(templates[index]);
      setStepNum(1);
    }
  };

  let contentElement;
  let actionElement;

  switch (stepNum) {
    case 0:
      contentElement = (
        <div className="flex w-full flex-1 flex-col gap-2">
          {templates?.map((item, index) => (
            <div
              key={item.id}
              role="button"
              onClick={() => handleTemplateSelection(index)}
              onKeyDown={() => handleTemplateSelection(index)}
              tabIndex={0}>
              <FundraiseTemplateCard
                isSelected={selectedTemplateIndex === index}
                template={item}
              />
            </div>
          ))}
        </div>
      );

      actionElement = <DialogActions />;
      break;
    case 1:
      {
        const processedId = selectedTemplate?.id;
        const processedTemplate = FUNDRAISERS.find((f) => f.id === processedId);

        switch (selectedTemplate?.id) {
          case 1:
          case 4:
          case 5:
            contentElement = (
              <CreateCampaignDialogTemplate
                open={open}
                type={FUNDRAISERS[processedId - 1].type}
                post={post}
                onClose={handleClose}
                updateHeader={handleUpdateHeader}
                handleBack={handleBack}
              />
            );
            break;
          case 2:
          case 3:
            contentElement = (
              <CreateCrowdFundingDialogTemplate
                open={open}
                type={FUNDRAISERS[processedId - 1].type}
                post={post}
                onClose={handleClose}
                updateHeader={handleUpdateHeader}
                handleBack={handleBack}
              />
            );
            break;
          default:
            break;
        }
        // if (selectedTemplateIndex >= 0 && selectedTemplateIndex < 3) {
        //   contentElement = (
        //     <CreateCampaignDialogTemplate
        //       open={open}
        //       type={FUNDRAISERS[selectedTemplateIndex].type}
        //       post={post}
        //       onClose={handleClose}
        //       updateHeader={handleUpdateHeader}
        //       handleBack={handleBack}
        //     />
        //   );
        // } else if (selectedTemplateIndex >= 3) {
        //   contentElement = (
        //     <CreateCrowdFundingDialogTemplate
        //       open={open}
        //       type={FUNDRAISERS[selectedTemplateIndex].type}
        //       post={post}
        //       onClose={handleClose}
        //       updateHeader={handleUpdateHeader}
        //       handleBack={handleBack}
        //     />
        //   );
        // }
      }

      actionElement = <></>;

      break;
    default:
      break;
  }

  return (
    <Dialog
      isOpen={open}
      onClose={closeDialog}
      maxWidth="lg"
      title={headerText}>
      <div className="flex w-full flex-col gap-12 p-0 lg:p-0">
        <div className="hidden items-center justify-between">
          {stepNum === 1 && (
            <Hidden mdUp>
              <StyledTextButton type="button" onClick={handleBack}>
                <MdArrowBackIos />
              </StyledTextButton>
            </Hidden>
          )}

          <div className="flex items-center justify-center text-center">
            <Typography variant="h2" className="uppercase text-chips-primary">
              {headerText}
            </Typography>
          </div>
          {/* 
          {stepNum === 1 && (
            <Hidden mdUp>
              <StyledTextButton type="button" onClick={handlePost}>
                {isEditMode ? 'Save' : 'Post'}
              </StyledTextButton>
            </Hidden>
          )} */}
          {stepNum !== 1 && (
            <Hidden mdUp>
              <StyledTextButton type="button" onClick={handleClose}>
                Close
              </StyledTextButton>
            </Hidden>
          )}
        </div>
        <div className="flex w-full flex-col items-start justify-start overflow-y-auto pr-4">
          {contentElement}
        </div>
        {actionElement}
      </div>
    </Dialog>
  );
}

export default CreateFundraiseDialog;
